import React from 'react';
import { Accordion, Grid, Table } from 'semantic-ui-react';
import SimpleAccordion from '@/components/accordion/SimpleAccordion';
import EntitiesErrorMessages from '@/components/errors/EntitiesErrorMessages';
import events from '../hooks/events';
import DatasetMetricsTable from '../../metrics/components/DatasetMetricsTable';
import DictionariesMetricsTable from '../../metrics/components/DictionariesMetricsTable';
import DatasetConditionsTable from '../../conditions/containers/DatasetConditionsTable';
import DatasetCollectionsTable from '../../collections/containers/DatasetCollectionsTable';
import DatasetSettingsTable from './DatasetSettingsTable';
import DatasetBasicSettingRows from '../containers/DatasetBasicSettingRows';
import DatasetCohortSettingRows from '../containers/DatasetCohortSettingRows';
import DatasetSubscriptionSettingRows from '../containers/DatasetSubscriptionSettingRows';
import DatasetRequestSettingRows from '../containers/DatasetRequestSettingRows';

const DatasetAdminGrid = ({
  category,
  children,
  code,
  hideCatalogue,
  hideMetrics,
  name,
  panels,
  saveErrors,
  datasourceSupportsCohort,
}) => {
  const updatePanels = events.useUpdateDatasetSettingsPanels(category, { code });
  const updateProperties = events.useUpdateDatasetSettingsProperties(category, { code });
  return (
    <Grid>
      <Grid.Row columns="equal">
        <Grid.Column>
          {children}
          <EntitiesErrorMessages
            category={category}
            code={code}
            entity="dataset-settings"
            errors={saveErrors}
            onDismiss={(errors) => updateProperties({ properties: { saveErrors: errors } })}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={8}>
          <Accordion>
            <SimpleAccordion
              active={panels.left.includes(0)}
              headerId="dataset.settings.custom.actions.title"
              index={0}
              onClick={() => updatePanels({ index: 0, panel: 'left' })}
            >
              <DatasetSettingsTable>
                <Table.Body>
                  <DatasetBasicSettingRows code={code} category={category} hideCatalogue={hideCatalogue} name={name} />
                </Table.Body>
              </DatasetSettingsTable>
            </SimpleAccordion>
            { datasourceSupportsCohort && (
              <SimpleAccordion
                active={panels.left.includes(1)}
                headerId="dataset.settings.cohort.title"
                index={1}
                onClick={() => updatePanels({ index: 1, panel: 'left' })}
              >
                <DatasetSettingsTable>
                  <Table.Body>
                    <DatasetCohortSettingRows code={code} category={category} name={name} />
                  </Table.Body>
                </DatasetSettingsTable>
              </SimpleAccordion>
            )}
            <SimpleAccordion
              active={panels.left.includes(2)}
              headerId="dataset.settings.subscriptions.title"
              index={2}
              onClick={() => updatePanels({ index: 2, panel: 'left' })}
            >
              <DatasetSettingsTable>
                <Table.Body>
                  <DatasetSubscriptionSettingRows code={code} category={category} name={name} />
                </Table.Body>
              </DatasetSettingsTable>
            </SimpleAccordion>
            {!hideMetrics && (
              <>
                <SimpleAccordion
                  active={panels.left.includes(3)}
                  headerId="dataset.settings.metrics.title"
                  index={3}
                  onClick={() => updatePanels({ index: 3, panel: 'left' })}
                >
                  <DatasetMetricsTable code={code} category={category} />
                </SimpleAccordion>
                <SimpleAccordion
                  active={panels.left.includes(4)}
                  headerId="dataset.settings.metrics.dictionaries.title"
                  index={4}
                  onClick={() => updatePanels({ index: 4, panel: 'left' })}
                >
                  <DictionariesMetricsTable code={code} category={category} />
                </SimpleAccordion>
              </>
            )}
          </Accordion>
        </Grid.Column>
        <Grid.Column width={8}>
          <Accordion>
            <SimpleAccordion
              active={panels.right.includes(0)}
              headerId="dataset.settings.requests.title"
              index={0}
              onClick={() => updatePanels({ index: 0, panel: 'right' })}
            >
              <DatasetSettingsTable>
                <Table.Body>
                  <DatasetRequestSettingRows code={code} category={category} name={name} />
                </Table.Body>
              </DatasetSettingsTable>
            </SimpleAccordion>
            <SimpleAccordion
              active={panels.right.includes(1)}
              headerId="dataset.settings.conditions.title"
              index={1}
              onClick={() => updatePanels({ index: 1, panel: 'right' })}
            >
              <DatasetConditionsTable code={code} category={category} name={name} />
            </SimpleAccordion>
            <SimpleAccordion
              active={panels.right.includes(2)}
              headerId="dataset.settings.collections.title"
              index={2}
              onClick={() => updatePanels({ index: 2, panel: 'right' })}
            >
              <DatasetCollectionsTable code={code} category="settings" name={name} />
            </SimpleAccordion>
          </Accordion>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default DatasetAdminGrid;
